export default __webpack_public_path__ + "static/media/step1_spam_outlook.a51f09d4.png";